import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { MagnifyingGlassIcon } from '@motorway/mw-highway-code';

import { MOT_VALUATION_ROUTE } from '../../../../../containers/app/checkerPages/Pages/CheckerRouter.utils';

import { ActionTile } from './ActionTile';
import LocalTexts from './ActionTiles.texts.json';

import styles from './MOTActionTile.module.scss';

const LocalT = new MDText(LocalTexts.mot);

type MOTActionTileProps = {
  onClick?: () => void;
};

export const MOTActionTile = ({ onClick }: MOTActionTileProps) => {
  const handleClick = () => {
    onClick?.();
  };

  return <Link data-thc-style-override className={styles.trackActionTile} onClick={handleClick} rel='noopener noreferrer' target='_blank' to={MOT_VALUATION_ROUTE}>
    <ActionTile icon={MagnifyingGlassIcon} text={LocalT.translate('text')} title={LocalT.translate('title')} />
  </Link>;
};
